import { BasketballMessagesSlice } from '@hefe/store';
import { useSelector } from 'react-redux';
import MessagesAppComponent from '../../../messages/components/messages-app/messages-app.component';

export default function AdminMessagesPages() {
  const loading = useSelector(
    BasketballMessagesSlice.basketballAdminMessagesLoadingSelector
  );
  const messages = useSelector(
    BasketballMessagesSlice.basketballAdminMessagesSelector
  );

  return (
    <MessagesAppComponent
      mode="admin"
      messages={messages}
      loading={loading}
      allowCompose={true}
      fetchMoreMessages={BasketballMessagesSlice.fetchBasketballAdminMessages}
    />
  );
}
